.textPart {
  display: inline;
}
